import { useFormContext } from 'react-hook-form';
import { Grid, Typography, Box } from '@mui/material';
import { selectFieldStyles, textFieldStyles } from 'quoting/new-quote/helpers';
import { specifiedMfgOptions } from 'shared/constants/quotes';
import { CheckBoxField, FormTextField, SelectField } from 'shared/controls';
import { useQueryProjectTypes } from 'shared/queries';

export const PlumberInfo = () => {
  const {
    formState: { errors },
    getValues,
  } = useFormContext();

  const { projectTypes, isLoading: isLoadingProjectTypes, isFetching: isFetchingProjectTypes } = useQueryProjectTypes();

  return (
    <Grid item xs={12} md={6}>
      <Typography mb={1} variant='h6'>
        Plumber Information
      </Typography>
      <FormTextField sx={textFieldStyles} name='plumberContractor' label='Contractor' />
      <Box sx={{ marginTop: 1 }}>
        <SelectField
          name='plumberProjectType'
          label='Project Type *'
          loading={isLoadingProjectTypes || isFetchingProjectTypes}
          options={projectTypes || []}
          getOptionLabel={opt => opt}
          isOptionEqualToValue={(option, value) => {
            if (!option || !value) return true;
            return option === value;
          }}
          rules={{
            validate: (value: string) => getValues('status') === 'DRAFT' || !!value || 'Project Type is required',
          }}
          error={Boolean(errors?.plumberProjectType)}
          helperText={errors?.plumberProjectType?.message}
          sx={selectFieldStyles}
        />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <FormTextField sx={textFieldStyles} name='plumberArchitect' label='Architect' />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <FormTextField sx={textFieldStyles} name='plumberEngineer' label='Engineer' />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <SelectField
          name='plumberSpecifiedMfg'
          label='Specified Mfg *'
          options={[...specifiedMfgOptions]}
          getOptionLabel={opt => opt}
          isOptionEqualToValue={(option, value) => {
            if (!option || !value) return true;
            return option === value;
          }}
          rules={{
            validate: (value: string) => getValues('status') === 'DRAFT' || !!value || 'Specified Mfg is required',
          }}
          error={Boolean(errors?.plumberSpecifiedMfg)}
          helperText={errors?.plumberSpecifiedMfg?.message}
          sx={selectFieldStyles}
        />
      </Box>
      <Box sx={{ marginTop: 1 }}>
        <CheckBoxField name='plumberOutOfTerritory' label='Out of Territory?' />
      </Box>
    </Grid>
  );
};
